<router-outlet></router-outlet>
<tbtk-snackbar (closed)="notificationService.snackbarVisibility.next(false)"></tbtk-snackbar>
